import { AppThunk, AppDispatch } from '@app/store/store'

import { actions } from './slice'

export const setCtmNumberReady = (): AppThunk => (dispatch: AppDispatch) => dispatch(actions.setCtmNumberReady())
